import React, { useRef, useState, useCallback, useEffect } from "react";
import { notifyScroll } from "../utils/scrollActivity";

// Web port of Android's verticalScrollEdgeFade (ScrollEdgeFade.kt): a soft
// gradient that fades the scroll content to transparent at the top/bottom edge
// — but only on a side that actually has more content to scroll past, so a list
// pinned to an end shows no fade there. Implemented with a CSS mask-image, the
// browser equivalent of Compose's BlendMode.DstIn gradient mask.
const FADE_PX = 40; // ~Android's 24dp, a touch larger to read well on desktop

const ScrollFadeContainer = ({ children, style, ...rest }) => {
  const ref = useRef(null);
  const [edges, setEdges] = useState({ top: false, bottom: false });

  const update = useCallback(() => {
    notifyScroll(); // pause title belts while the list is scrolling
    const el = ref.current;
    if (!el) return;
    const top = el.scrollTop > 1;
    const bottom = el.scrollTop + el.clientHeight < el.scrollHeight - 1;
    setEdges((prev) =>
      prev.top === top && prev.bottom === bottom ? prev : { top, bottom }
    );
  }, []);

  // Recompute when content changes (e.g. tasks load / tab switches).
  useEffect(() => {
    update();
  }, [update, children]);

  const topStop = edges.top ? `transparent 0, #000 ${FADE_PX}px` : "#000 0";
  const bottomStop = edges.bottom
    ? `#000 calc(100% - ${FADE_PX}px), transparent 100%`
    : "#000 100%";
  const mask = `linear-gradient(to bottom, ${topStop}, ${bottomStop})`;

  return (
    <div
      ref={ref}
      onScroll={update}
      style={{ ...style, WebkitMaskImage: mask, maskImage: mask }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default ScrollFadeContainer;
